// IMPORT REACT
import React, { Component } from "react";
import { Switch, Route, withRouter } from "react-router-dom";

// IMPORT CONTAINERS
import Page from "../Page/";
import Resources from "../Page/Resources/";
import NotFound from "../NotFound/";


// IMPORT STYLES
import { Sc_TransitionWrapper, Sc_TransitionGroup, Sc_CSSTransition, Sc_RouteSection } from '../styles';

class Routes extends Component {
  render() {
    return (

      <Switch location={this.props.location}>
        <Route exact path={["/"]} component={Page} />
        <Route exact path="/:resources/:categoryid/" component={Page} />
        <Route exact path="/:slug/" component={Page} />
        <Route component={NotFound} />
      </Switch>

    );
  }
}


export default withRouter(Routes);
